<template>
  <CDropdown
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item d-md-down-none mx-2 mr-3"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <div @click="updateSeen">
        <CHeaderNavLink>
          <CIcon name="cil-bell"/>
          <CBadge shape="pill" v-if="itemsCount > 0" color="danger">{{ itemsCount }}</CBadge>
        </CHeaderNavLink>
      </div>
    </template>
    <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>Thông báo mới nhận</strong>
    </CDropdownHeader>
    <div class="content-notification" style="overflow-x: hidden; max-height: 300px;max-width: 400px;"
         v-if="itemsCount > 0 || lstNotification.length > 0">
      <CDropdownItem v-for="item in lstNotification" :key="item.id"
                     :class="item.isSeen ? 'seen d-block' : 'not-seen d-block'"
                     style="min-width: 400px;white-space: break-spaces;">
        <i class="fa fa-circle mr-2" :class="item.isSeen ? 'text-success' : 'text-warning'"></i>
        {{ item.content }}
        <div class="mb-1" style="text-align: right">
          <small class="text-muted">{{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}</small>
        </div>
      </CDropdownItem>
    </div>
    <div v-else>
      <CDropdownItem>
        Bạn không có thông báo mới
      </CDropdownItem>
    </div>
    <CDropdownHeader tag="div">
      <center>
        <span class="text-right read-more" style="cursor: pointer;color: #000000ad;font-weight: 500;"
              @click="$router.push('/notification-management').catch(() => {})">
          Xem tất cả...
        </span>
      </center>
    </CDropdownHeader>
    <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>Thông tin máy chủ</strong>
    </CDropdownHeader>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>CPU</b></small>
      </div>
      <CProgress class="progress-xs" :color="changeColorCpu" :value="monitor.cpuUsage"/>
      <small class="text-muted">{{ monitor.processTotal }} Process</small>
    </CDropdownItem>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>RAM</b></small>
      </div>
      <CProgress class="progress-xs" :color="changeColorMem" :value="monitor.memoryPercent"/>
      <small class="text-muted">{{ monitor.memoryUsage ? monitor.memoryUsage.toFixed(1) : 0 }}
        GB/{{ monitor.memoryTotal ? monitor.memoryTotal.toFixed(1) : 0 }} GB</small>
    </CDropdownItem>
  </CDropdown>
</template>
<script>
import { LOCATION_CODE_NAME } from '../constant';
export default {
  name: 'TheHeaderDropdownNotif',
  data() {
    return {
      itemsCount: 0,
      lstNotification: [],
      monitor: {}
    }
  },
  mounted() {
    this.connectWebSocket();
  },
  computed: {
    changeColorMem: function () {
      let that = this
      if (that.monitor.memoryPercent > 90) {
        return 'danger'
      } else if (that.monitor.memoryPercent > 70) {
        return 'warning'
      } else {
        return 'info'
      }
    },
    changeColorCpu: function () {
      let that = this
      if (that.monitor.cpuUsage > 90) {
        return 'danger'
      } else if (that.monitor.cpuUsage > 70) {
        return 'warning'
      } else {
        return 'info'
      }
    }
  },
  methods: {
    connectWebSocket: function () {
      let that = this
      that.$connectSocket(successCallback => {
        if (successCallback) {
          successCallback.subscribe("/user/notification", notification => {
            that.loadNotification(notification)
          })
          that.$sendMessageSocket("/app/server.message.notification", null, {})

          successCallback.subscribe("/notification", notification => {
            if(notification.locationCode == localStorage.getItem(LOCATION_CODE_NAME)) {
              that.loadNotification(notification)
            }
          });

          successCallback.subscribe("/monitor", monitor => {
            let data = JSON.parse(monitor.body);
            that.monitor = data
          });
          that.$sendMessageSocket("/app/server.message.monitor", null, {})
        }
      }, errorCallback => {
        console.log(errorCallback)
      })
    },

    loadNotification(notification) {
      let that = this
      let data = JSON.parse(notification.body)
      // var dataExist = [];
      // for(var i = 0; i < that.lstNotification.length; i++){
      //   dataExist.push(that.lstNotification[i].id)
      // }
      // for(var i = 0; i < data.length; i++){
      //   if(!dataExist.includes(data[i].id)){
      //     that.lstNotification.push(data[i])
      //   }
      // }
      // that.lstNotification = that.lstNotification.sort(function(a,b){
      //   return new Date(b.createDate) - new Date(a.createDate)
      // })
      that.lstNotification = data.lstNotification;
      that.itemsCount = data.totalNotSeen;
    },

    updateSeen: function () {
      let that = this
      if (that.itemsCount > 0) {
        this.$helper.loadDataSource({
          url: "/notification/update-seen",
          dataSubmit() {
            return {}
          },
          ignoreDefaultData: true,
          successCallback: function (response) {
            that.itemsCount = 0;
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      }
    },
  }
}
</script>

<style scoped>
.read-more:hover {
  text-decoration: underline;
}

.c-icon {
  margin-right: 0.3rem;
}

.not-seen {
  background-color: #dcdddd38;
}

.not-seen:hover {
  background-color: white;
}
</style>

